<div class="text-slate-900 dark:text-slate-100 h-screen flex flex-col overflow-hidden font-sans bg-white dark:bg-slate-950">
  
  <!-- Top Header -->
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>

  <div class="flex flex-1 overflow-hidden relative">
    
    <!-- Sidebar (Desktop only) -->
    <app-sidebar-admin
      class="hidden lg:flex"
      [isOpen]="isSidebarOpen()"
      (toggleSidebar)="toggleSidebar()"
    ></app-sidebar-admin>

    <!-- Main Scrollable Content -->
    <main class="flex-1 overflow-y-auto bg-slate-50/50 dark:bg-slate-950/50 relative pb-20 lg:pb-0 flex flex-col justify-between min-w-0">
      <div class="max-w-full mx-auto p-3.5 sm:p-4 md:p-6 lg:p-10 pb-8 lg:pb-10 w-full flex-1">
        <router-outlet></router-outlet>
      </div>

      <!-- Footer Copyright DevAssociate -->
      <app-footer></app-footer>

      <!-- Subtle background glow -->
      <div class="fixed top-1/4 -right-1/4 w-[500px] h-[500px] bg-brand-500/5 rounded-full blur-[120px] pointer-events-none"></div>
    </main>

  </div>

  <!-- Mobile Bottom Navigation -->
  <app-bottom-nav role="ADMIN"></app-bottom-nav>

  <!-- Global Floating Suggestion Widget -->
  <app-suggestion-widget></app-suggestion-widget>
</div>
